import type { LoanApplyMarketReqType } from '@/api/apply-product/types';
import { EquityPathType } from '@/api/apply-product/types';
import type { RightPackageTypeEnum, RightsSummaryGet } from '@/api/rights/types';
import { PricingTypeEnum } from '@/enums/rights';

/** 用于存储用户购买了臻享卡的权益包信息和当前提现提现，下单时校验是否匹配 */
export const loanAndRightsParamasMap = new Map<string, RightsSummaryGet>();
export const checkEquityValue = (
  equityValue: EquityPathType,
  rightParams: LoanApplyMarketReqType,
  pricingType?: PricingTypeEnum,
): boolean => {
  if (equityValue === EquityPathType.BUY_RIGHTS) {
    // 不存在用户标签的话，直接check是否有核心下单参数
    if (!pricingType) {
      return !!rightParams?.packageId;
    }
    return [
      PricingTypeEnum.LOAN_24_WITH_RIGHTS,
      PricingTypeEnum.LOAN_24_MUST_RIGHTS,
      PricingTypeEnum.LOAN_24_MUST_RIGHTS_OR_LOAN_36,
      PricingTypeEnum.LOAN_24_SELECT_RIGHTS_OR_NOT,
    ].includes(pricingType) && !!rightParams?.packageId;
  }
  // 如果不需要购买权益，则直接校验 pricingType 是否为空，或者 pricingType 是否为 4，6中的一种
  if (equityValue === EquityPathType.NORMAL) {
    return !pricingType || (
      pricingType && [
        PricingTypeEnum.LOAN_24_WITH_RIGHTS,
        PricingTypeEnum.LOAN_24_MUST_RIGHTS,
        PricingTypeEnum.LOAN_24_SELECT_RIGHTS_OR_NOT,
      ].includes(pricingType));
  }
  return true;
};

// 提现下单参数是否和权益档位匹配
export const checkParamsMatch = (
  loanParams: {amount: number; period: number},
  rightParams: LoanApplyMarketReqType,
): boolean => {
  const { amount, period } = loanParams;
  if (!rightParams?.packageId && rightParams?.equityPath === EquityPathType.BUY_RIGHTS) {
    return false;
  }
  const requestRightParams = rightParams?.packageId
    ? loanAndRightsParamasMap.get(rightParams?.packageId) : undefined;
  if (requestRightParams) {
    const { orderAmount: amountVal, period: periodVal } = requestRightParams;
    return amount === amountVal && period === periodVal;
  }
  return true;
};

/** 验证当前的卡包type 是否和 对应的匹配 */
export const checkPackageType = (
  rightParams: LoanApplyMarketReqType,
  rightPackageType: RightPackageTypeEnum,
): boolean => {
  if (rightParams?.packageType !== rightPackageType) {
    return false;
  }
  return true;
};
